var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificate-item flex"},[(!_vm.disabled)?[_c('upload',{attrs:{"props-data":{
        bizType: 'enterprise',
        attachmentType: 'bank_license',
        uploadMode: 'fileId',
        photoWall: true,
        photoWallStyle: {
          width: '140px',
          height: '140px'
        },
        watermark: 1,
        watermarkText: '精彩纵横云采购注册认证使用，不可用于其它使用，违者必究',
        fileIdBefore: _vm.fileId,
        fileSize: 5,
        onSuccess: fileId => _vm.$emit('change', fileId)
      }}}),_c('div',{staticClass:"edit-desc"},[_c('p',{staticClass:"desc-title"},[_vm._v(_vm._s(_vm.uploadTitle))]),_c('div',{staticClass:"desc-con"},[_vm._t("uploadDesc",function(){return [_c('p',[_vm._v(_vm._s(_vm.uploadDesc))])]})],2),(_vm.samplePictureUrl)?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.showSamplePicture}},[_vm._v("查看示例图片")]):_vm._e(),(_vm.templateDownloadUrl)?_c('download-file',{staticClass:"m-l-20",attrs:{"download-link":_vm.templateDownloadUrl}},[_c('span',{staticClass:"text-btn font-14"},[_vm._v("模板下载")])]):_vm._e()],1)]:[_c('preview-image',{attrs:{"file-id":_vm.fileId,"need-preview":true,"need-wrapper":true,"width":"200px","height":"120px"}}),_c('p',{staticClass:"not-edit-desc"},[_vm._v(" "+_vm._s(_vm.uploadTitle)+" ")])],(_vm.samplePictureDialog)?_c('el-image-viewer',{attrs:{"on-close":() => (_vm.samplePictureDialog = false),"url-list":[_vm.samplePictureUrl]}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }